import Image from "next/image";
import React from "react";
const currentYear = new Date().getFullYear();

const Footer: React.FC = () => {
  return (
    <div className="w-screen py-8 bg-slate-100 flexer gap-3 lg:gap-6 text-slate-600">
      <p className="hidden lg:block">{`2017-${currentYear}`}</p>
      <Image
        src="/Images/footerLogo.png"
        alt="Footer Logo"
        width={200}
        height={800}
      />
      <p className="flexer gap-2">
        <b className="block lg:hidden">{currentYear}</b> &copy; All rights
        reserved.{" "}
      </p>
    </div>
  );
};
export default Footer;
